import StudentStoriesSlider from '@/ui/Slidersection';
import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const StudentStoriesSection = ({ data, loading }) => {
  const getMediaUrl = (media) => {
    if (!media) return null;
    if (typeof media === 'string') return media;
    
    const baseUrl = process.env.NEXT_PUBLIC_STRAPI_URL || "http://localhost:1337";
    const url = media.url || media.data?.attributes?.url || media.data?.url;
    
    if (!url) return null;
    if (url.startsWith("http")) return url;
    return `${baseUrl}${url}`;
  };

  const title = data?.Student_title || "Don't Just Take Our Word for It - Hear from Medhavians";
  const subText = ""; // No subtext in current Strapi schema for this component

  const students = data?.Student_Testimonial_blocks?.map(block => ({
    name: block?.student_name,
    image: getMediaUrl(block?.Thumbnail_image) || Student1,
    videLink: getMediaUrl(block?.long_video_url),
    shortUrl: getMediaUrl(block?.short_video)
  })) || [];

  if (loading && !data) {
    return (
      <div className='max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)] py-12'>
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-1/2 mb-8" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="h-64 bg-gray-200 rounded-xl" />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]'>
      <StudentStoriesSlider
        title={title}
        subText={subText}
        students={students}
      />
    </div>
  );
};

export default StudentStoriesSection;
